import Empty from 'constants/empty';
import { createSelector } from 'reselect';
import { testTargetOffersSelector } from 'selectors/testTarget/offers/testTargetOffersSelector';

const relatedSearchesSelector = createSelector(testTargetOffersSelector, offers => offers.relatedSearches || Empty.Object);

export { relatedSearchesSelector };
